// extracted by mini-css-extract-plugin
export default {"categoryIcon":"CategoryIcon_categoryIcon__WDqw1"};